import React from 'react';
import { Link } from 'react-router-dom'; // jeśli używasz React Router

const Footer = () => {
  return (
    <footer className="bg-darkGrey text-[#fdfcf9] py-12 px-6">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-10 text-sm">
        {/* Kolumna 1: Logo / nazwa */}
<div>
  <img src="/images/logotest2.png" alt="Psychoterapia Marciniec" className="h-16 mb-2" />
  <p className="text-[#e8e4dc]">
    Profesjonalne wsparcie psychologiczne i psychoterapeutyczne w przyjaznej atmosferze.
  </p>
</div>

        {/* Kolumna 2: Nawigacja */}
        <div>
          <h4 className="text-[#d2a391] uppercase font-semibold tracking-wider mb-3">Nawigacja</h4>
          <ul className="space-y-2">
            <li><a href="/#onas" className="hover:text-[#d2a391] transition">O nas</a></li>
            <li><a href="#oferta" className="hover:text-[#d2a391] transition">Oferta</a></li>
            <li><Link href="/rezerwacja" className="hover:text-[#d2a391] transition">Rejestracja</Link></li>
            <li><a href="/#kontakt" className="hover:text-[#d2a391] transition">Kontakt</a></li>
          </ul>
        </div>

        {/* Kolumna 3: Kontakt */}
        <div>
          <h4 className="text-[#d2a391] uppercase font-semibold tracking-wider mb-3">Kontakt</h4>
          <ul className="space-y-2">
            <li className="text-[#e8e4dc]">ul. Rynek 11 38-600 Lesko</li>
            <li>tel: <a href="tel:+48665189478" className="hover:text-[#d2a391] transition">+48 665 189 478</a></li>
            <li>email: <a href="mailto:marciniec21@gmail.com" className="hover:text-[#d2a391] transition">marciniec21@gmail.com</a></li>
          </ul>
        </div>
      </div>

      {/* Stopka dolna */}
      <div className="text-center text-xs text-[#e8e4dc] mt-10">
        © {new Date().getFullYear()} Psychoterapia Marciniec. Wszelkie prawa zastrzeżone.
      </div>
    </footer>
  );
};

export default Footer;
